<template>
	<v-carousel hide-delimiters show-arrows>
		<v-carousel-item
				v-for="(item,i) in images"
				:key="i"
				:src="item.src"
				reverse-transition="fade-transition"
				transition="fade-transition"
				class="carousel-image"
		></v-carousel-item>
	</v-carousel>
</template>

<script>
	export default {
		name: "ImageGallery",
		data() {
			return {
				images: [
					{
						src: require('../assets/img/P1013559.jpg')
					},
					{
						src: require('../assets/img/P1013566.jpg')
					},
					{
						src: require('../assets/img/P1013573.jpg')
					},
					{
						src: require('../assets/img/P1013577.jpg')
					},
					{
						src: require('../assets/img/P1013580.jpg')
					},
					{
						src: require('../assets/img/P1013587.jpg')
					},
					{
						src: require('../assets/img/P1013589.jpg')
					},
					{
						src: require('../assets/img/P1013591.jpg')
					},
					{
						src: require('../assets/img/P1013593.jpg')
					},
					{
						src: require('../assets/img/P1013594.jpg')
					},
					{
						src: require('../assets/img/P1013597.jpg')
					},
					{
						src: require('../assets/img/P1013501.jpg')
					},
					{
						src: require('../assets/img/P1013524.jpg')
					}
				]
			}
		}
	}
</script>

<style scoped lang="scss">
	.v-carousel {
		z-index: 300 !important;
	}
</style>
